// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__1gc7m","content":"LoadingAlert_content__2lO-_"};